(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5631],{

/***/ 95631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content023": function() { return /* binding */ Content023; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14258);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52853);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87900);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87367);
/* harmony import */ var _Content023_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13298);
/* harmony import */ var _Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var Content023 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var points = (ref2 = payload === null || payload === void 0 ? void 0 : payload.points) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    var ref4 = (ref3 = payload === null || payload === void 0 ? void 0 : payload.requestButton) !== null && ref3 !== void 0 ? ref3 : {}, buttonText = ref4.buttonText, form = ref4.form, type = ref4.type, link = ref4.link;
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_3__/* .buildWidgetInstanceId */ .G1)("023", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__/* .WIDGETS_REGISTRY.CONTENT */ .R.CONTENT);
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().query;
    var ref5 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useToggle */ .OT)(), opened = ref5.opened, onOpen = ref5.onOpen, onClose = ref5.onClose;
    var baseUrl =  true ? window.location.origin : 0;
    var externalLink = (link === null || link === void 0 ? void 0 : link.startsWith("http")) || (link === null || link === void 0 ? void 0 : link.startsWith("https")) ? link : "".concat(baseUrl).concat(link);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W2, {
            className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().inner),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().blocks),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().left),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Heading3 */ .aC, {
                                as: "h3",
                                className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, {
                                value: description,
                                className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().description),
                                color: "dark"
                            }),
                            type === "external link" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                href: externalLink,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().button),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().play),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                            className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon),
                                            name: "arrow_right"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                        color: "brand",
                                        className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["button-text"]),
                                        children: buttonText
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Action */ .aU, {
                                onClick: onOpen,
                                className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().button),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().play),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                            className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon),
                                            name: "arrow_right"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                        color: "brand",
                                        className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["button-text"]),
                                        children: buttonText
                                    })
                                ]
                            }),
                            opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ModalWrapper */ .AB, {
                                onCloseModal: onClose,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                    item: form,
                                    metaData: {
                                        page: query.slug
                                    },
                                    instanceId: instanceId,
                                    onReset: onClose
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().right),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .AccordionList */ .ES, {
                            items: points,
                            className: (_Content023_module_scss__WEBPACK_IMPORTED_MODULE_8___default().list),
                            appearance: "bold"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content023);


/***/ }),

/***/ 13298:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content023_wrapper__VuWAM","blocks":"Content023_blocks__FFVkj","left":"Content023_left__TKTOU","right":"Content023_right__eukyx","title":"Content023_title__TnsR4","description":"Content023_description__lOgJd","list":"Content023_list__qWCBN","button":"Content023_button__xDvB8","play":"Content023_play__VQ_Cw","icon":"Content023_icon__VYW_3","button-text":"Content023_button-text__tE6gd"};

/***/ })

}]);